import GrAuthenticationProfile from "./GrAuthenticationProfile.vue";

export { GrAuthenticationProfile };
